/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import { styled as muiStyled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TextField from "src/components/core/TextField";
import AddIcon from "@mui/icons-material/Add";
import Stack from "@mui/material/Stack";

import { Chip } from "@mui/material";

import styled from "styled-components";

import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";

import { createFilterOptions, Autocomplete } from "@mui/material";

import Button from "src/components/core/Button";

import { useDialog } from "src/context/DialogContext";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";

import MoodAddDialog from "./MoodAddDialog";
import LabelSection from "src/components/core/LabelSection";
import ImageIcon from "@mui/icons-material/Image";

import font from "src/styles/font";
import { hexToRgba } from "src/common/color";

import { arrayMove } from "@dnd-kit/sortable";
import DraggableBoard from "src/components/core/DraggableBoard";
import MoodBannerAddDialog from "./MoodBannerAddDialog";
import MoodRoomAddDialog from "./MoodRoomAddDialog";
import { DraggableItem } from "src/components/core/DraggableBoard";
import { Grey, White, White01 } from "src/styles/color";
import { MoreHoriz } from "@mui/icons-material";

import Dropdown from "src/components/core/Dropdown";

import {
  deleteMood,
  getAllMoodsByAdmin,
  togglePublicMood,
  getAllRooms,
  moveRoomPosition,
  togglePublicRoom,
  deleteRoom,
  getAllBanners,
  moveBannerPosition,
  togglePublicBanner,
  deleteBanner,
} from "src/api/shopThisMood";

const BoxWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  // display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
`;

const drawerWidth = 260;

const Main = muiStyled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
}));

const DrawerHeader = muiStyled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
  height: "75px",
}));

const S = {};

S.BannerListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;

S.BannerItemWrapper = styled(DraggableItem)`
  position: relative;
  width: 100%;
  padding-top: calc(100% / (1440 / 540));
  background-color: #f3f1f2;
  border-radius: 16px;
  background-image: url(${(props) => props.$backgroundImage});
  background-size: cover;
  background-position: center;
`;

S.BannerItemAction = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  padding: 8px;
`;

S.BannerContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  opacity: 0;
  transition: all 0.2s;

  &:hover {
    opacity: 1;
  }
`;

S.RoomListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
`;

S.RoomItemWrapper = styled(DraggableItem)`
  position: relative;
  width: 100%;
  padding: 8px 16px;
  border-radius: 16px;
  border: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
`;

S.RoomName = styled.span`
  font-size: 16px;
  font-weight: 500;
  user-select: none;
  white-space: nowrap;
`;

S.RoomItemAction = styled.div`
  display: flex;
  align-items: center;
`;

const ImageEmpty = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: #f2f1f3;
  border-radius: 16px;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;
  margin-right: 8px;
  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
`;

const ImgDisplay = styled.img`
  width: 56px;
  height: 56px;
  object-fit: cover;
  object-position: center;
  border-radius: 8px;
  flex-shrink: 0;
`;

S.RoomMoodItemWrapper = styled.div`
  position: relative;
  /* width: 100%; */
  padding-top: 100%;
  border-radius: 16px;
  background-image: url(${(props) => props.$backgroundImage});
  background-size: cover;
  background-position: center;
`;

S.RoomMoodItemAction = styled.div`
  /* position: absolute;
  top: 0;
  right: 0; */
  display: flex;
  align-items: center;
  padding: 8px;
  align-self: flex-end;
  z-index: 1;
`;

S.RoomMoodContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  opacity: 0;
  transition: all 0.2s;

  &:hover {
    opacity: 1;
  }
`;

S.RoomMoodName = styled.h4`
  margin: 0;
  padding: 16px;
  color: ${White};
  z-index: 1;
  /* font-size: ${font.size.sm}; */
`;

S.ItemBackdrop = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 16px;
`;

function ShopThisMood({ open }) {
  const { enqueueSnackbar } = useSnackbar();
  const { openDialog, closeDialog, closeAllDialogs } = useDialog();

  const navigate = useNavigate();

  const handleSearchingTimeout = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [dataSearch, setDataSearch] = useState({
    keyword: null,
    page: 0,
    page_size: 10,
    sortBy: "createdAt",
    sortOrder: "desc",
  });

  const [moods, setMoods] = useState([]);
  const [recentlyMoods, setRecentlyMoods] = useState([]);

  const [banners, setBanners] = useState([]);

  const [rooms, setRooms] = useState([]);

  const fetchBanners = async () => {
    try {
      const result = await getAllBanners();
      setBanners(result);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchRooms = async () => {
    try {
      const result = await getAllRooms();
      setRooms(result);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchMoods = async () => {
    try {
      const { result } = await getAllMoodsByAdmin(dataSearch);
      setMoods(result);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchRecentlyMoods = async () => {
    try {
      const { result } = await getAllMoodsByAdmin({
        page_size: 16,
        ...dataSearch,
      });
      setRecentlyMoods(result);
    } catch (err) {
      console.error(err);
    }
  };

  const handleTogglePublicBanner = async (id, isPublic) => {
    try {
      await togglePublicBanner(id, isPublic);
      await fetchBanners();
    } catch (err) {
      console.error(err);
    }
  };

  const handleDeleteBanner = async (id) => {
    try {
      await deleteBanner(id);
      await fetchBanners();
    } catch (err) {
      console.error(err);
    }
  };

  const handleTogglePublicMood = async (id, isPublic) => {
    try {
      await togglePublicMood(id, isPublic);
      await fetchRecentlyMoods();
    } catch (err) {
      console.error(err);
    }
  };

  const handleDeleteMood = async (id) => {
    try {
      await deleteMood(id);
      await fetchRecentlyMoods();
    } catch (err) {
      console.error(err);
    }
  };

  const handleTogglePublicRoom = async (id, isPublic) => {
    try {
      await togglePublicRoom(id, isPublic);
      await fetchRooms();
    } catch (err) {
      console.error(err);
    }
  };

  const handleDeleteRoom = async (id) => {
    try {
      await deleteRoom(id);
      await fetchRooms();
    } catch (err) {
      console.error(err);
    }
  };

  const handleSearchMoods = () => {
    setIsLoading(true);
    clearTimeout(handleSearchingTimeout.current);
    handleSearchingTimeout.current = setTimeout(async () => {
      await fetchMoods();
      setIsLoading(false);
    }, 500);
  };

  useEffect(() => {
    handleSearchMoods();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSearch.keyword]);

  useEffect(() => {
    fetchRecentlyMoods();
    fetchRooms();
    fetchBanners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Main open={open}>
        <DrawerHeader />
        <BoxWrapper>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              // marginBottom: 3,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginRight: 2,
                width: "100%",
              }}
            >
              <Autocomplete
                // freeSolo
                aria-required={true}
                getOptionSelected={(option, value) =>
                  option?._id === value?._id
                }
                isOptionEqualToValue={(option, value) =>
                  option?._id === value?._id
                }
                renderOption={(props, option, { selected }) => (
                  <li
                    {...props}
                    key={`item-${option?._id}`}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {!!option?.media?.image === false ? (
                        <ImageEmpty>
                          <InsertPhotoIcon
                            sx={{
                              color: "rgba(0, 0, 0, 0.54)",
                              cursor: "pointer",
                            }}
                          />
                        </ImageEmpty>
                      ) : (
                        <ImgDisplay
                          src={
                            option?.media?.image
                              ? option?.media?.image.replace(
                                  ".com",
                                  ".com/300x300",
                                )
                              : ""
                          }
                          alt={option?.media?.image}
                        />
                      )}
                      <Stack style={{ marginLeft: 16 }}>
                        <Typography component="span">
                          {option?.mood_name}
                        </Typography>
                        <Typography component="span">
                          {option?.room?.room_th}
                        </Typography>
                      </Stack>
                    </Box>
                    <Stack direction="row" gap={1}>
                      {option?.hashtags?.slice(0, 3).map((hashtag) => (
                        <Chip
                          key={hashtag?.name}
                          label={hashtag?.name}
                          variant="outlined"
                        />
                      ))}
                      {option?.hashtags?.length > 3 && (
                        <Chip
                          label={`+${option?.hashtags?.length - 3}`}
                          variant="outlined"
                        />
                      )}
                    </Stack>
                  </li>
                )}
                options={moods}
                // limitTags={2}
                onInputChange={(event, newInputValue) => {
                  setDataSearch({
                    ...dataSearch,
                    keyword: newInputValue,
                  });
                }}
                value={null}
                loading={isLoading}
                onChange={(event, newValue) => {
                  openDialog({
                    type: "custom",
                    customDialog: (
                      <MoodAddDialog
                        initialValue={newValue}
                        onClose={() => closeDialog()}
                        onSuccess={() => {
                          fetchMoods();
                          closeAllDialogs();
                        }}
                        editable
                      />
                    ),
                  });
                }}
                getOptionLabel={(option) => {
                  return (
                    option?.mood_name +
                    "-" +
                    option?.room?.room_th +
                    "-" +
                    option?.room?.room_en +
                    "-" +
                    option?.room?.room_cn +
                    "-" +
                    option?.styles?.map((style) => style.name).join(",")
                  );
                }}
                // filterOptions={createFilterOptions({
                //   matchFrom: "any",
                //   limit: 100,
                // })}
                sx={{
                  // mt: 2,
                  // mb: 3,
                  width: "100%",
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{
                      maxWidth: "100%",
                      width: "100%",
                    }}
                    placeholder="ค้นหาโดย ชื่อมูด / ชื่อห้อง / ชื่อสไตล์"
                  />
                )}
              />
            </Box>
            <Button
              variant="contained"
              startIcon={<ImageIcon />}
              onClick={() =>
                openDialog({
                  type: "custom",
                  customDialog: (
                    <MoodAddDialog
                      onClose={() => closeDialog()}
                      onSuccess={() => {
                        fetchMoods();
                        closeAllDialogs();
                      }}
                    />
                  ),
                })
              }
              size="large"
              sx={{
                minWidth: 200,
              }}
            >
              เพิ่มภาพมูด
            </Button>
          </Box>
        </BoxWrapper>
        <BoxWrapper>
          <LabelSection
            title="แบนเนอร์"
            description="คุณสามารถลากแบนเนอร์เพื่อสลับตำแหน่งได้"
            actionMenu={() => (
              <Button
                startIcon={<AddIcon />}
                variant="secondary"
                size="large"
                sx={{
                  minWidth: 200,
                }}
                onClick={() => {
                  openDialog({
                    type: "custom",
                    customDialog: (
                      <MoodBannerAddDialog
                        onClose={() => closeDialog()}
                        onSuccess={() => {
                          fetchBanners();
                          closeAllDialogs();
                        }}
                      />
                    ),
                  });
                }}
              >
                เพิ่มแบนเนอร์
              </Button>
            )}
          >
            <DraggableBoard
              items={banners}
              onDragEnd={async ({ active, over }) => {
                if (active.id !== over?.id) {
                  const oldIndex = banners.findIndex(
                    (item) => item._id === active.id,
                  );
                  const newIndex = banners.findIndex(
                    (item) => item._id === over.id,
                  );

                  const newReArranged = arrayMove(banners, oldIndex, newIndex);

                  setBanners(newReArranged); // optimistic update

                  try {
                    await moveBannerPosition(newReArranged);
                  } catch (err) {
                    setBanners(banners); // if error, revert to original order
                    console.error(err);
                  }
                }
              }}
              Components={{
                DroppableParent: ({ items, children }) => {
                  return (
                    <S.BannerListContainer>
                      {children({ items })}
                    </S.BannerListContainer>
                  );
                },
                DraggableItem: (props) => {
                  const { item, items, ...rest } = props; // Destructuring items to prevent this spreading to html element
                  return (
                    <S.BannerItemWrapper
                      $backgroundImage={item?.image}
                      {...rest}
                    >
                      {!item?.is_public && (
                        <S.ItemBackdrop>
                          <VisibilityOffIcon
                            sx={{
                              color: White,
                            }}
                          />
                        </S.ItemBackdrop>
                      )}
                      <S.BannerContainer>
                        {item?.is_public && <S.ItemBackdrop />}
                        <S.BannerItemAction>
                          <Dropdown
                            renderButton={(props) => (
                              <IconButton
                                sx={{
                                  color: White,
                                  backgroundColor: hexToRgba(White, 0.4),
                                }}
                                {...props}
                              >
                                <MoreHoriz />
                              </IconButton>
                            )}
                            options={[
                              {
                                label: item?.is_public ? "ซ่อน" : "แสดง",
                                startIcon: item?.is_public ? (
                                  <VisibilityOffIcon />
                                ) : (
                                  <VisibilityIcon />
                                ),
                                onClick: () => {
                                  openDialog({
                                    type: "confirm",
                                    title: `คุณต้องการ${
                                      item?.is_public ? "ปิด" : "เปิด"
                                    }การมองเห็นใช่หรือไม่?`,
                                    onConfirm: () => {
                                      handleTogglePublicBanner(
                                        item?._id,
                                        !item?.is_public,
                                      );
                                      closeDialog();
                                    },
                                    maxWidth: 342,
                                  });
                                },
                              },
                              {
                                label: "ลบ",
                                startIcon: <DeleteOutlineRoundedIcon />,
                                onClick: () => {
                                  openDialog({
                                    type: "confirm",
                                    title: "คุณต้องการลบใช่หรือไม่?",
                                    onConfirm: () => {
                                      handleDeleteBanner(item?._id);
                                      closeDialog();
                                    },
                                    maxWidth: 342,
                                  });
                                },
                              },
                            ]}
                          />
                        </S.BannerItemAction>
                      </S.BannerContainer>
                    </S.BannerItemWrapper>
                  );
                },
              }}
            />
          </LabelSection>
        </BoxWrapper>
        <BoxWrapper>
          <LabelSection
            title="ห้อง"
            description="คุณสามารถลากห้องเพื่อสลับตำแหน่งได้"
            actionMenu={() => (
              <Button
                startIcon={<AddIcon />}
                variant="secondary"
                size="large"
                sx={{
                  minWidth: 200,
                }}
                onClick={() => {
                  openDialog({
                    type: "custom",
                    customDialog: (
                      <MoodRoomAddDialog
                        onClose={() => closeDialog()}
                        onSuccess={() => {
                          fetchRooms();
                          closeAllDialogs();
                        }}
                      />
                    ),
                  });
                }}
              >
                เพิ่มห้อง
              </Button>
            )}
          >
            <DraggableBoard
              items={rooms}
              onDragEnd={async ({ active, over }) => {
                if (active.id !== over?.id) {
                  const oldIndex = rooms.findIndex(
                    (item) => item._id === active.id,
                  );
                  const newIndex = rooms.findIndex(
                    (item) => item._id === over.id,
                  );

                  const newReArranged = arrayMove(rooms, oldIndex, newIndex);

                  setRooms(newReArranged); // optimistic update

                  try {
                    await moveRoomPosition(newReArranged);
                  } catch (err) {
                    setRooms(rooms); // if error, revert to original order
                    console.error(err);
                  }
                }
              }}
              Components={{
                DroppableParent: ({ items, children }) => {
                  return (
                    <S.RoomListContainer>
                      {children({ items })}
                    </S.RoomListContainer>
                  );
                },
                DraggableItem: (props) => {
                  const { item, items, ...rest } = props; // Destructuring items to prevent this spreading to html element

                  return (
                    <S.RoomItemWrapper
                      {...rest}
                      style={{
                        ...(!item?.is_public && {
                          backgroundColor: White01,
                        }),
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          left: 0,
                          top: 0,
                          width: "100%",
                          height: "100%",
                        }}
                        onClick={() => {
                          navigate(`/shop-this-mood/${item._id}`);
                        }}
                      ></div>
                      <S.RoomItemAction>
                        {!item?.is_public && (
                          <VisibilityOffIcon
                            sx={{
                              width: 22,
                              height: 22,
                              mr: 1,
                              color: Grey,
                            }}
                          />
                        )}
                        <S.RoomName
                          style={{
                            ...(!item?.is_public && {
                              color: Grey,
                            }),
                          }}
                        >
                          {item?.room_th}
                        </S.RoomName>
                      </S.RoomItemAction>
                      <S.RoomItemAction>
                        <Dropdown
                          options={[
                            {
                              label: "แก้ไข",
                              startIcon: <EditRoundedIcon />,
                              onClick: () => {
                                openDialog({
                                  type: "custom",
                                  customDialog: (
                                    <MoodRoomAddDialog
                                      initialValue={item}
                                      onClose={() => closeDialog()}
                                      onSuccess={() => {
                                        fetchRooms();
                                        closeAllDialogs();
                                      }}
                                      editable
                                    />
                                  ),
                                });
                              },
                            },
                            {
                              label: item?.is_public ? "ซ่อน" : "แสดง",
                              startIcon: item?.is_public ? (
                                <VisibilityOffIcon />
                              ) : (
                                <VisibilityIcon />
                              ),
                              onClick: () => {
                                openDialog({
                                  type: "confirm",
                                  title: `คุณต้องการ${
                                    item?.is_public ? "ปิด" : "เปิด"
                                  }การมองเห็นใช่หรือไม่?`,
                                  onConfirm: () => {
                                    handleTogglePublicRoom(
                                      item?._id,
                                      !item?.is_public,
                                    );
                                    closeDialog();
                                  },
                                  maxWidth: 342,
                                });
                              },
                            },
                            {
                              label: "ลบ",
                              startIcon: <DeleteOutlineRoundedIcon />,
                              onClick: () => {
                                openDialog({
                                  type: "confirm",
                                  title: "คุณต้องการลบใช่หรือไม่?",
                                  onConfirm: () => {
                                    handleDeleteRoom(item?._id);
                                    closeDialog();
                                  },
                                  maxWidth: 342,
                                });
                              },
                            },
                          ]}
                        />
                      </S.RoomItemAction>
                    </S.RoomItemWrapper>
                  );
                },
              }}
            />
          </LabelSection>
        </BoxWrapper>
        <BoxWrapper>
          <LabelSection title="ล่าสุด">
            <S.RoomListContainer>
              {recentlyMoods.slice(0, 16).map((item) => {
                return (
                  <S.RoomMoodItemWrapper
                    $backgroundImage={item?.media?.image}
                    key={item._id}
                  >
                    {!item?.is_public && (
                      <S.ItemBackdrop>
                        <VisibilityOffIcon
                          sx={{
                            color: White,
                          }}
                        />
                      </S.ItemBackdrop>
                    )}
                    <S.RoomMoodContainer>
                      {item?.is_public && <S.ItemBackdrop />}
                      <S.RoomMoodItemAction>
                        <Dropdown
                          renderButton={(props) => (
                            <IconButton
                              sx={{
                                color: White,
                                backgroundColor: hexToRgba(White, 0.4),
                              }}
                              {...props}
                            >
                              <MoreHoriz />
                            </IconButton>
                          )}
                          options={[
                            {
                              label: "แก้ไข",
                              startIcon: <EditRoundedIcon />,
                              onClick: () => {
                                openDialog({
                                  type: "custom",
                                  customDialog: (
                                    <MoodAddDialog
                                      initialValue={item}
                                      onClose={() => closeDialog()}
                                      onSuccess={() => {
                                        fetchRecentlyMoods();
                                        closeAllDialogs();
                                      }}
                                      editable
                                    />
                                  ),
                                });
                              },
                            },
                            {
                              label: item?.is_public ? "ซ่อน" : "แสดง",
                              startIcon: item?.is_public ? (
                                <VisibilityOffIcon />
                              ) : (
                                <VisibilityIcon />
                              ),
                              onClick: () => {
                                if (!item?.room?.is_public) {
                                  enqueueSnackbar(
                                    `ไม่สามารถปรับการมองเห็นภาพนี้ได้ เนื่องจาก
                                  ”${item?.room?.room_th}” ถูกซ่อนอยู่
                                  กรุณาเปิดแสดงการมองเห็น ”${item?.room?.room_th}” ก่อน`,
                                    {
                                      variant: "error",
                                      autoHideDuration: 5000,
                                    },
                                  );
                                } else {
                                  openDialog({
                                    type: "confirm",
                                    title: `คุณต้องการ${
                                      item?.is_public ? "ปิด" : "เปิด"
                                    }การมองเห็นใช่หรือไม่?`,
                                    onConfirm: () => {
                                      handleTogglePublicMood(
                                        item?._id,
                                        !item?.is_public,
                                      );
                                      closeDialog();
                                    },
                                    maxWidth: 342,
                                  });
                                }
                              },
                            },
                            {
                              label: "ลบ",
                              startIcon: <DeleteOutlineRoundedIcon />,
                              onClick: () => {
                                openDialog({
                                  type: "confirm",
                                  title: "คุณต้องการลบใช่หรือไม่?",
                                  onConfirm: () => {
                                    handleDeleteMood(item?._id);
                                    closeDialog();
                                  },
                                  maxWidth: 342,
                                });
                              },
                            },
                          ]}
                        />
                      </S.RoomMoodItemAction>
                      <S.RoomMoodName>{item?.mood_name}</S.RoomMoodName>
                    </S.RoomMoodContainer>
                  </S.RoomMoodItemWrapper>
                );
              })}
            </S.RoomListContainer>
          </LabelSection>
        </BoxWrapper>
      </Main>
    </>
  );
}

export default ShopThisMood;
